<template>
  <div>
    <Card title="Referral About List">
      <template v-slot:button>
        <Button v-if="isEdit" @clicked="cancelEdit" variant="default" label="Cancel" />
        <Button @clicked="actionEdit" variant="primary" :label="textButtonEdit" />
      </template>
      <template v-slot:body>
        <p v-if="$v.data.$dirty && !$v.data.minLength" class="text-red-500 italic mt-2 text-left">List at least have 1 item</p>
        <el-table :data="data" row-key="id" :show-header="false" style="width: 100%">
          <el-table-column label="Actions" align="left" width="450px">
            <template slot-scope="scope">
              <div class="static inline-block text-left container-action w-full">
                <div class="relative">
                  <p class="font-bold">Text</p>
                  <input type="text" class="block border border-grey-light w-full p-3 rounded"
                         :class=" ($v.data.$each[scope.$index].text.$dirty && !$v.data.$each[scope.$index].text.required) ? 'border-red-500' : ''"
                         v-model.trim="$v.data.$each[scope.$index].text.$model"
                         :disabled="!isEdit"
                  />
                </div>
                <p v-if="$v.data.$each[scope.$index].text.$dirty && !$v.data.$each[scope.$index].text.required" class="text-red-500 text-xs italic text-left">Please fill the Text.</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Actions" align="left" width="350px">
            <template slot-scope="scope">
              <div class="static inline-block text-left container-action w-full">
                <div class="relative">
                  <p class="font-bold">Sub Text</p>
                  <input type="text" class="block border border-grey-light w-full p-3 rounded"
                         v-model.trim="data[scope.$index].sub_text"
                         :disabled="!isEdit"
                  />
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Actions" align="right">
            <template slot-scope="scope">
              <div class="static inline-block text-left container-action">
                <VueCustomTooltip label="Delete" :position="'is-left'" v-if="isEdit">
                  <button @click="del(scope)" class="p-2 mr-2 rounded bg-red-500 hover:bg-red-600 focus:outline-none" >
                    <font-awesome-icon class="text-white" :icon="['fa', 'trash-alt']" />
                  </button>
                </VueCustomTooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <Button v-if="isEdit" @clicked="addList" variant="primary" label="Add List" class="w-full mt-4"/>
      </template>
    </Card>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { minLength, required } from 'vuelidate/lib/validators';
import helpersMixin from '@/mixins/helpers.mixins';
import { mapActions, mapGetters } from 'vuex';
import { Button, FormItem, Input, TextError } from '@/components/Layout/Form';
import Card from '@/components/Layout/Card.vue';

export default {
  name: 'ReferralAbout',
  mixins: [validationMixin, helpersMixin],
  data() {
    return {
      data: [],
      dataOrigin: [],
      isEdit: false,
      lastId: 0,
    };
  },
  validations() {
    return {
      data: {
        required,
        minLength: minLength(1),
        $each: {
          text: {
            required,
          },
        },
      },
    };
  },
  computed: {
    ...mapGetters('NotificationModule', ['getErrorCode', 'getMessage', 'getStatus']),
    textButtonEdit() {
      return this.isEdit ? 'Save' : 'Edit';
    },
  },
  async mounted() {
    await this.refineData();
  },
  methods: {
    ...mapActions('AppSettingModule', [
      'requestGetReferralAbout', 'requestSetReferralAbout',
    ]),
    async refineData() {
      const data = await this.requestGetReferralAbout();
      const lists = [];
      let lastId = 0;
      data.forEach((opt, index) => {
        lists.push({
          text: opt.text,
          sub_text: opt.sub_text ? opt.sub_text : '',
        });
        lastId++;
      });
      this.lastId = lastId;
      this.dataOrigin = JSON.parse(JSON.stringify(lists));
      this.data = JSON.parse(JSON.stringify(lists));
    },
    async actionEdit() {
      if (this.isEdit) {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          await this.requestSetReferralAbout({data: [...this.data]});
          if (this.getStatus === 200) {
            this.$swal('Referral About List Saved', '', 'success');
            await this.refineData();
            this.isEdit = false;
            this.$v.$reset();
          } else if (this.getStatus === 400 && this.getErrorCode === 'error-save-referral-about') {
            this.$swal('Error', this.getMessage, 'error');
          }
        }
      } else {
        this.isEdit = true;
        this.data = [];
        this.data = JSON.parse(JSON.stringify(this.dataOrigin));
      }
    },
    cancelEdit() {
      this.isEdit = false;
      this.$v.$reset();
      this.data = [];
      this.data = JSON.parse(JSON.stringify(this.dataOrigin));
    },
    del(scope) {
      this.data.splice(scope.$index, 1);
    },
    addList() {
      this.data.push({
        text: '',
        sub_text: '',
      });
    },
  },
  components: {
    Button,
    Card,
    FormItem, Input, TextError
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/AppSetting/ReferralAbout.vue